export { hoursSummary } from "./schema";

export const telHref = (s) => `tel:${s.phone}`;

export const waHref = (s, msg) =>
  `https://wa.me/${String(s.whatsapp).replace(/\D/g, "")}?text=${encodeURIComponent(msg ?? s.whatsapp_message)}`;

export const igHref = (s) => s.instagram_url || `https://www.instagram.com/${s.instagram_handle}/`;
